import { render } from "./ForgotPasswordSendEmailPage.vue?vue&type=template&id=6a522d24&scoped=true&ts=true"
import script from "./ForgotPasswordSendEmailPage.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordSendEmailPage.vue?vue&type=script&lang=ts"

import "./ForgotPasswordSendEmailPage.vue?vue&type=style&index=0&id=6a522d24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a522d24"]])

export default __exports__